module.exports = __webpack_public_path__ + "static/media/ruler-vertical.99be7c29.svg";